import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MechanicsService } from '../_services/mechanics.service';

@Component({
	selector: 'mode-selector',
	templateUrl: './mode-selector.component.html',
	styleUrls: ['./mode-selector.component.css']
})
export class ModeSelectorComponent {

	constructor(private router: Router, private ms: MechanicsService) {

		delete ms.preferences.selectedMode

		// -> not saving to preferences after all, offering the choce every time

		// Check if user has a saved mode preference
		// Do this in constructor to redirect before component displays
		// if (this.ms.preferences.selectedMode) {
			// Automatically navigate to the saved mode
		// 	this.router.navigate([this.ms.preferences.selectedMode]);
		// }
	}

	navigateToLearningMode() {

		// not saving to preferences after all, offering the choce every time
		// this.ms.preferences.selectedMode = '/learningmode';
		// this.ms.savePreferences();


		this.router.navigate(['/learningmode']);
	}

	navigateToProductionMode() {

		this.ms.layout = "pastilles"; // Not used in production mode, but necessary to display the options button...
		
		// not saving to preferences after all, offering the choce every time
		// this.ms.preferences.selectedMode = '/productionmode';
		// this.ms.savePreferences();
		this.router.navigate(['/productionmode']);
	}

}
